module.exports = __webpack_public_path__ + "static/8-15a54882d48bbb2b50f6dee89fdd0e21.jpg";